import { Flinserl, AmmonitenArt, Trommelweibertrommel, Pfeifferl } from "../../Utils/GlbLoaderArtefakte.jsx";
import ExperienceModelViewer from "../ExperienceModelViewer.jsx";

export default function ArtefaktBundlesKHofBadAusee({ currentMuseumId }) {
  const { flinserl } = Flinserl();
  const { ammonitenArt } = AmmonitenArt();
  const { trommelweibertrommel } = Trommelweibertrommel();
  const { pfeifferl } = Pfeifferl();

  const artefactArray = [flinserl, ammonitenArt, trommelweibertrommel, pfeifferl];

  return <ExperienceModelViewer modelArray={artefactArray} currentMuseumId={currentMuseumId} />;
}
